import { useCallback, useRef, useState } from 'react';

import { useVesselProductUpdates } from '../../../common/hooks/useVesselProductUpdates';

interface LubricationChartProcessing {
    isProcessing: boolean;
    startProcessing: () => Promise<number>;
    cancelProcessing: () => void;
}

export const useLubricationChartProcessing = (vesselId?: string, customerId?: string): LubricationChartProcessing => {
    const [isProcessing, setIsProcessing] = useState(false);
    const processingResolveRef = useRef<((productCount: number) => void) | null>(null);

    const startProcessing = useCallback(() => {
        setIsProcessing(true);
        return new Promise<number>((resolve) => {
            processingResolveRef.current = resolve;
        });
    }, []);

    const cancelProcessing = useCallback(() => {
        processingResolveRef.current = null;
        setIsProcessing(false);
    }, []);

    const completeProcessing = useCallback((productCount: number) => {
        processingResolveRef.current?.(productCount);
        processingResolveRef.current = null;
        setIsProcessing(false);
    }, []);

    useVesselProductUpdates(vesselId, customerId, completeProcessing);

    return {
        isProcessing,
        startProcessing,
        cancelProcessing,
    };
};
